/*
* CoreAjax is used by HmAjax.
* only difference latter handles the session validity.
*
*/
var CoreAjax = function(url,data,headers){
	var startTime = 0;
	var timeTakenInSecs = 0;
	var opts = {};

	var availableMethods = ['GET','POST','PUT','DELETE'];
	var dataStr = "";
	
	if(typeof headers === 'object'){
		dataStr = data;
	}else{
		if(typeof data === 'object'){
			try{
				dataStr = JSON.stringify(data);
			}catch(e){}
		}else{
			dataStr = data;
		}
	}

	var calcResponseTime = function(){
		try{
			timeTakenInSecs = Math.round(((new Date().getTime() - startTime) / 1000)* 100) / 100;
			opts.timeTakenInSecs = timeTakenInSecs;		
		}catch(e){}
	}


	this.get = function(success, failure){
	  this.connect('GET',success, failure);
	}

	this.post = function(success, failure){
		this.connect('POST',success, failure);
	}

	this.put = function(success, failure){
		this.connect('PUT',success, failure);	
	}

	this.delete = function(success, failure){
 		this.connect('DELETE',success, failure);		
 	}

	this.connect = function(method, success, failure){
		if(availableMethods.indexOf(method) === -1){
			//if method not defined, default is applied
			method = availableMethods[0];
		}

	   var defaultParams  = {
		    method: method,
		    mode:'cors',
		    redirect:'follow',
		    credentials:'include',
		    headers:{
		     'Accept':  '*'  
		   }
		};

		 
		 if(method === 'GET'){
		   try{
			   if(typeof data === "object" && Object.keys(data).length > 0){
			     url += "?";
			     for(var i in data){
			       url += i + "=" + data[i] + "&";
			     }
			     url = url.substring(0,url.length-1);
			   }
			 }catch(e){
			  console.error(e);
			}
		}else{
		  defaultParams.headers["Content-Type"]="application/json";
		  defaultParams.body = dataStr;	
		}
		 
		 
		 try{
		   if(typeof headers === "object" && Object.keys(headers).length > 0){		     
		     for(var key in headers){
		    	 defaultParams.headers[key] = headers[key];
		     }		    
		   }
		 }catch(e){
		  console.error(e);
		 }
			 
		startTime = new Date().getTime();
	
		fetch(url, defaultParams).then(response => response.json()).then(
	        (result) => {
	        	calcResponseTime();
	        	try{
	            	if(typeof success === "function"){
	            		success.apply(this,[result, opts]);	
	            	}
	            }catch(e){
	            	console.error("Error occurred while calling the success handler:",e);
	            }
	        },
	        (error) => {
	        	calcResponseTime();
	           	try{
	        		if(typeof failure === "function"){
	            	failure.apply(this,[error, opts]);
	            	}
	            }catch(e){
	            	console.error("Error occurred while calling the failure handler:",e);
	            }
	        }
	    )
	}
		
}

export default CoreAjax;


// WEBPACK FOOTER //
// ./src/util/CoreAjax.js